import React from 'react';
import {
	EditorSelectionContext,
	TextLineSelection,
} from './EditorSelectionContext';

export const EditorSelectionContextProvider: React.FC<{
	textLine?: TextLineSelection;
	children: React.ReactNode;
}> = ({textLine = null, children}) => {
	const [selectedTextLine, setSelectedTextLine] =
		React.useState<TextLineSelection>(textLine);

	const value = React.useMemo(
		() => ({selectedTextLine, setSelectedTextLine}),
		[selectedTextLine],
	);

	return (
		<EditorSelectionContext.Provider value={value}>
			{children}
		</EditorSelectionContext.Provider>
	);
};
